export interface CancelReasons {
    id: number
    related_status_id: number
    name: string
    needs_comment: boolean
    is_active: boolean
    description: string
}

export enum CancelReasonRelatedId {
    PedidoEmAnalise = 2,
    CotacaoCancelada = 20,
    PecaRejeitadaPeloComprador = 22,
    PecaRejeitadaPeloVendedor = 23,
}
